export default function nav() {
	
	$('.burger').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('.mobile-menu').toggleClass('active');
    $('body').toggleClass('mobile-menu-opened');
  });

  $('.menu').each(function(){
    if ($(this).find('li.current-menu-item, li.current-page-ancestor').length > 0) {
      $(this).addClass('has-active');
    }
  });
}